<app-dialog-container
  [title]="data.title"
  [confirmButtonText]="data.confirmButtonText"
  [confirmButton]="data.confirmButton"
  [cancelButtonText]="data.cancelButtonText"
  [isValid]="!isChoiceInvalid"
  [confirmButtonDisabled]="isChoiceInvalid"
  (confirmButtonHandler)="data.choiceControl?.markAsTouched()"
>
  <mat-dialog-content class="content-container">
    @if (data.content) {
      <ng-container *ngTemplateOutlet="data.content"></ng-container>
    } @else if (data.messages?.length) {
      @for (message of data.messages; track $index) {
        @if ($index > 0) {
          <hr class="confirm-dialog-message-divider" />
        }
        <p>{{ message }}</p>
      }
      @if (data.showAreYouSure) {
        <p>{{ 'areYouSure' | translate }}?</p>
      }
    } @else {
      <p>
        {{ data.message | translate: { entityName: data.entityName } }}
        @if (!data.ownPunctuationMark) {
          <span>{{ data.list?.length ? ':' : '.' }}</span>
        }
      </p>
      @if (data.choiceControl && data.choiceOptions?.length) {
        <app-shared-ui-radio
          class="confirm-dialog-choice"
          [control]="data.choiceControl"
          [options]="data.choiceOptions || []"
          [required]="true"
        ></app-shared-ui-radio>
      }
      @if (data.list?.length && data.entityType) {
        <p>
          {{
            'ifYouConfirmRemovalSparePartsBackInStock'
              | translate: { entityType: data.entityType | translate }
          }}
        </p>
        <ul>
          @for (item of data.list; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      }
      @if (data.warningMessage) {
        <div class="warning-message-container-confirm-dialog">
          <mat-icon class="warning-icon-confirm-dialog">warning</mat-icon>
          <p class="warning-message-confirm-dialog">
            {{ data.warningMessage | translate }}
          </p>
        </div>
      }
      @if (data.showAreYouSure) {
        <p>{{ 'areYouSure' | translate }}?</p>
      }
    }
  </mat-dialog-content>
</app-dialog-container>
